<div class="lobbies-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">Lobbies</h1>
        <p class="page-subtitle">Manage and monitor all lobbies within the application.</p>
      </div>

    </div>
  </div>

  <!-- Lobby Form Component (for both Create and Edit) -->
  <app-lobby-form [show]="showLobbyForm" [lobby]="selectedLobby" [themes]="themes" [themesLoading]="themesLoading"
  [creating]="creating" (closeForm)="closeLobbyForm()" (submitForm)="handleLobbyFormSubmit($event)"></app-lobby-form>

  <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-3">
    <div class="d-flex align-items-center gap-3">
      <app-search-box tooltipText="Search By name and theme" [value]="searchTerm"
      (search)="onSearchInput($event)"></app-search-box>
      <div class="date-filter">
        <input type="date" class="form-control" placeholder="dd-mm-yyyy" [(ngModel)]="selectedDate"
          (change)="onDateFilter()" />
        </div>
        @if (hasSelection()) {
          <button class="btn btn-icon btn-delete-bulk" (click)="deleteSelectedLobbies()"
            title="Delete Selected">
            <i class="pi pi-trash" style="font-size: 1.25rem;"></i>
          </button>
        }
      </div>

      <div class="d-flex align-items-center gap-3 ms-auto">
        <div class="d-flex align-items-center gap-2 border rounded px-1 header-icon-actions-wrapper">
          <button type="button" class="btn btn-icon p-1 header-icon-action-btn" (click)="loadLobbies()" title="Refresh">
            <i class="pi pi-refresh" style="font-size: 1.25rem; color: #6b7280;"></i>
          </button>
          <button type="button" class="btn btn-icon p-1 tooltip-wrap header-icon-action-btn"
            (click)="includeDeleted = !includeDeleted; loadLobbies()">
            <i class="pi pi-asterisk" style="font-size: 1.25rem;"
            [style.color]="includeDeleted ? '#ec4899' : '#6b7280'"></i>
            <span class="tooltip-box">Include Mark Deleted</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Table Section -->
    <div class="table-container shadow">
      <table class="lobbies-table">
        <thead>
          <tr>
            <th class="checkbox-col">
              <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()" />
            </th>
            <th class="sortable" (click)="onSort('host')">
              Host <span class="sort-indicator" [class.active]="currentSortField() === 'host'">{{ getSortIcon('host')
            }}</span>
          </th>
          <th class="sortable" (click)="onSort('theme')">
            Theme/Title <span class="sort-indicator" [class.active]="currentSortField() === 'theme'">{{
          getSortIcon('theme') }}</span>
        </th>
        <th class="sortable" (click)="onSort('startTime')">
          Start Time <span class="sort-indicator" [class.active]="currentSortField() === 'startTime'">{{
        getSortIcon('startTime') }}</span>
      </th>
      <th class="sortable" (click)="onSort('price')">
        Price <span class="sort-indicator" [class.active]="currentSortField() === 'price'">{{ getSortIcon('price')
      }}</span>
    </th>
    <th class="sortable text-center" (click)="onSort('entries')">
      Participants <span class="sort-indicator" [class.active]="currentSortField() === 'entries'">{{
    getSortIcon('entries') }}</span>
  </th>
  <th class="sortable text-center" (click)="onSort('interest')">
    Interest <span class="sort-indicator" [class.active]="currentSortField() === 'interest'">{{
  getSortIcon('interest') }}</span>
</th>
<th class="text-center">
  Spectators
</th>
<th class="sortable" (click)="onSort('revenue')">
  Revenue <span class="sort-indicator" [class.active]="currentSortField() === 'revenue'">{{
getSortIcon('revenue') }}</span>
</th>
<th class="text-center">Action</th>
</tr>
</thead>
<tbody>
  @if (loading()) {
    <tr>
      <td colspan="100%">
        <app-spinner-loader [width]="35" />
      </td>
    </tr>
  } @else if (paginatedLobbies.length === 0) {
    <tr>
      <td colspan="100%" class="no-data-cell">No lobbies found</td>
    </tr>
  } @else {
    @for (lobby of paginatedLobbies; track trackByLobbyId($index, lobby)) {
      <tr [class.selected]="lobby.selected"
        [ngClass]="{'deleted-row': !!lobby.isDeleted}" class="clickable-row" (click)="onRowClick($event, lobby)">
        <td class="checkbox-col">
          <input type="checkbox" [(ngModel)]="lobby.selected" (change)="onLobbySelect()"
            (click)="$event.stopPropagation()" />
          </td>
          <td class="host">
            <div class="d-flex align-items-center gap-2">
              <div class="avatar position-relative" [class.avatar-img-wrap]="!!lobby.hostPhotoUrl"
                [style.cursor]="lobby.hostPhotoUrl ? 'pointer' : 'default'" (click)="openHostPreview($event, lobby)">
                @if (lobby.hostPhotoUrl) {
                  <img [src]="lobby.hostPhotoUrl" alt="Profile" class="avatar-photo" />
                }
                @if (!lobby.hostPhotoUrl) {
                  <span>
                    {{ lobby.hostInitials }}
                  </span>
                }
                @if (lobby.isDeleted) {
                  <span class="deleted-dot" [pTooltip]="'Deleted Lobby'"
                  tooltipPosition="top"></span>
                }
              </div>
              <div class="d-flex align-items-center">
                <span class="fw-semibold me-2 text-clip" [pTooltip]="lobby.host" tooltipPosition="top">{{ lobby.host |
                titlecase }}</span>
                <span class="status-dot" [ngClass]="lobby.status.toLowerCase()" [pTooltip]="lobby.status"
                tooltipPosition="top"></span>
              </div>
            </div>
          </td>
          <td class="theme-title">
            <div class="d-flex align-items-center gap-2">
              <span>{{ lobby.theme }}</span>
            </div>
          </td>
          <td class="start-time">
            {{ lobby.startTime | date: 'yyyy-MM-dd HH:mm' }}
          </td>
          <td class="price">
            {{ lobby.price === 0 ? 'Free' : ('$' + lobby.price + '.00') }}
          </td>
          <td class="entries text-center">{{ lobby.entries }}/{{ lobby.capacity }}</td>
          <td class="interest text-center">
            {{ lobby.interestsCount ? (lobby.currentInterestIdx ?? 0) + 1 : 0 }} / {{ lobby.interestsCount ?? 0 }}
          </td>
          <td class="spectators text-center">
            {{ lobby.spectatorsList?.length || 0 }}
          </td>
          <td class="revenue">${{ lobby.revenue }}.00</td>
          <td class="text-center">
            <button class="btn btn-view" (click)="$event.stopPropagation(); viewEdit(lobby)">View</button>
          </td>
        </tr>
      }
    }
  </tbody>
</table>

<!-- Pagination Section -->
<div class="pagination-section">
  <div class="pagination-info">
    <span>
      Showing {{ startIndex }} to {{ endIndex }} of {{ totalEntries }} Entries
    </span>
  </div>
  <div class="d-flex gap-2">
    @if (lobbies.length !== 0) {
      <label class="page-size-label" for="pageSizeSelect">Page Size:</label>
      <select id="pageSizeSelect" [(ngModel)]="itemsPerPage" (ngModelChange)="onPageSizeChange($event)"
        class="form-select">
        @for (size of pageSizes; track size) {
          <option [value]="size">
            {{ size }}
          </option>
        }
      </select>
    }
    <button class="btn btn-outline pagination-btn"
      [disabled]="currentPage === 1 || loading() || lobbies.length === 0" (click)="previousPage()">
      &lt; Prev
    </button>
    <button class="btn btn-outline pagination-btn"
      [disabled]="currentPage >= totalPages || totalPages === 0 || loading() || lobbies.length === 0"
      (click)="nextPage()">
      Next &gt;
    </button>
  </div>
</div>
</div>
</div>

@if (isView() && selectedLobby) {
  <app-lobby-details-modal [visible]="isView()" (onClose)="closeView()" [lobby]="selectedLobby">
  </app-lobby-details-modal>
}

@if (previewPhotoUrl()) {
  <div class="photo-preview-overlay" (click)="closePreview()">
    <button class="preview-close-btn" (click)="closePreview()" aria-label="Close">
      <i class="pi pi-times"></i>
    </button>
    <img [src]="previewPhotoUrl()!" alt="Host photo" class="preview-img" (click)="$event.stopPropagation()" />
  </div>
}